import React from 'react';
import './App.css';
import { HashLink } from 'react-router-hash-link';

import leftArrow from './images/1x/galdisa_blog_left_arrow.png';
import rightArrow from './images/1x/galdisa_blog_right_arrow.png';

class Cuadro extends React.Component {

    constructor() {
        super();
        this.state = {
            selected: false,
        }
    }

    render() {
        const producto = this.props.producto;
        return (<div
            className="Cuadro"
            key={producto.key.toString()}
            to={producto.link}
            scroll={el => { el.scrollIntoView(true); window.scrollBy(0, -120) }}
            onClick={() => { this.setState({ selected: !this.state.selected }) }}
        >
            <img className="producto" src={producto.imagen} style={{ width: '100%', height: '100%' }} alt={producto.nombre} />
            <span>{producto.nombre}</span>
            {this.state.selected &&
                <div class='texto-m' style={{ fontWeight: '600', borderRadius: '16px', width: '80%', position: 'absolute', top: '0px', left: '0px', height: '100%', backgroundColor: 'rgb(65,150,78)', color: 'white', padding: '16px', textAlign: 'justify', boxSizing: 'border-box', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    {producto.description}
                    <a style={{ fontWeight: '600', backgroundColor: 'white', color: 'rgb(65,150,78)', borderRadius: '16px', textDecoration: 'none', padding: '16px' }} href={producto.ficha} target='_blank' rel='noopener noreferrer'>Descargar ficha</a>
                </div>
            }
        </div >)
    }
}

class Cuadricula extends React.Component {
    constructor() {
        super();
        this.state = {
            selectedIndex: 0,
            selections: {},
        }
        this.selectNext = this.selectNext.bind(this);
        this.selectPrev = this.selectPrev.bind(this);
        this.showSelection = this.showSelection.bind(this);
    }

    selectNext() {
        let newIndex = this.state.selectedIndex + 1;
        newIndex %= this.props.productos.length;
        this.setState({
            selectedIndex: newIndex
        });
    }
    selectPrev() {
        let newIndex = this.state.selectedIndex - 1;
        if (newIndex < 0) {
            newIndex = this.props.productos.length - 1;
        }
        this.setState({
            selectedIndex: newIndex
        });
    }
    showSelection() {
        const baseIndex = this.state.selectedIndex;
        const size = this.props.productos.length;
        const selection = [];
        for (let i = 0; i < this.props.productos.length; i++) {
            const producto = this.props.productos[(baseIndex + i) % size];
            console.log(producto);
            selection.push(
                <Cuadro producto={producto} />
            )
        }
        return selection;
    }

    render() {
        return (
            <div style={{ width: '100%', margin: "0 auto" }}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    {
                        this.props.productos.length > 4 && <div className="arrow" onClick={this.selectPrev}>
                            <img style={{ width: '16px' }} src={leftArrow} alt="izquierda" />
                        </div>
                    }
                    <div className="Cuadricula">
                        {
                            this.showSelection()
                        }
                    </div>
                    {
                        this.props.productos.length > 4 && <div className="arrow" onClick={this.selectNext}>
                            <img style={{ width: '16px' }} src={rightArrow} alt="izquierda" />
                        </div>
                    }
                </div>
                <div style={{ paddingTop: "40px" }}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export default Cuadricula;
